import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import Sidebar from './components/Sidebar';
import SidebarNexus from './components/SidebarNexus';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import HomePageNexus from './pages/HomePageNexus';
import HomePageDashboard from './pages/HomePageDashboard';
import WorkflowMarketPage from './pages/WorkflowMarketPage';
import WorkflowMarketPageNexus from './pages/WorkflowMarketPageNexus';
// import WorkflowProjectPage from './pages/WorkflowProjectPage';
//WorkflowExecutePage
import BeautySingImgPage from './pages/BeautySingImgPage';
import WorkflowExecutePage1 from './pages/WorkflowExecutePage-1';
import TaskQueuePage from './pages/TaskQueuePage';
import TaskQueuePageNexus from './pages/TaskQueuePageNexus';
import ImageUpscalePage from './pages/ImageUpscalePage';
import ImageToVideoPage from './pages/ImageToVideoPage';
import CloudServerPage from './pages/CloudServerPage';
import CloudServerPageNexus from './pages/CloudServerPageNexus';
import SettingsPage from './pages/SettingsPage';
import SettingsPageNexus from './pages/SettingsPageNexus';
import LoginPage from './pages/LoginPage';
import AIConversationPage from './pages/AIConversationPage';
import ProfilePage from './pages/ProfilePage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './styles/global.css';

const { Content } = Layout;

const AppContent: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { isLoggedIn, isAuthLoading } = useAuth();

  // 认证状态初始化中，显示加载状态，避免刷新时因 isLoggedIn 初始值导致路由跳转
  if (isAuthLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="加载中..." />
      </div>
    );
  }

  // 如果用户未登录，直接跳转到登录页面
  if (!isLoggedIn) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // 用户已登录，显示主应用界面（NexusAI风格 + 左侧菜单）
  return (
    <div style={{ minHeight: '100vh', display: 'flex' }}>
      <SidebarNexus collapsed={collapsed} onCollapse={setCollapsed} />
      <div style={{ 
        marginLeft: collapsed ? '80px' : '256px', 
        flex: 1,
        transition: 'margin-left 0.3s'
      }}>
        <Routes>
          <Route path="/" element={
            <ProtectedRoute>
              <HomePageDashboard />
            </ProtectedRoute>
          } />
            <Route path="/workflow-market" element={
              <ProtectedRoute>
                <WorkflowMarketPageNexus />
              </ProtectedRoute>
            } />
            <Route path="/workflow-market/beauty-sing-image" element={
              <ProtectedRoute>
                <BeautySingImgPage />
              </ProtectedRoute>
            } />
            {/* AI对话页面路由 - 通过market_id动态匹配 */}
            <Route path="/ai-conversation/:marketId" element={
              <ProtectedRoute>
                <AIConversationPage />
              </ProtectedRoute>
            } />
            {/* <Route path="/workflow-market/beauty-sing-video" element={
              <ProtectedRoute>
                <WorkflowExecutePage1 />
              </ProtectedRoute>
            } /> */}
            {/* <Route path="/workflow-project" element={
              <ProtectedRoute>
                <WorkflowProjectPage />
              </ProtectedRoute>
            } /> */}
            <Route path="/task-queue" element={
              <ProtectedRoute>
                <TaskQueuePageNexus />
              </ProtectedRoute>
            } />
            <Route path="/image-upscale" element={
              <ProtectedRoute>
                <ImageUpscalePage />
              </ProtectedRoute>
            } />
            <Route path="/image-to-video" element={
              <ProtectedRoute>
                <ImageToVideoPage />
              </ProtectedRoute>
            } />
            <Route path="/cloud-server" element={
              <ProtectedRoute>
                <CloudServerPageNexus />
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <SettingsPageNexus />
              </ProtectedRoute>
            } />
            {/* 二级菜单路由 */}
            {/* <Route path="/workflow/beauty-singing-image" element={
              <ProtectedRoute>
                <WorkflowProjectPage />
              </ProtectedRoute>
            } />
            <Route path="/workflow/beauty-singing-video" element={
              <ProtectedRoute>
                <WorkflowProjectPage />
              </ProtectedRoute>
            } />
            <Route path="/workflow/beauty-dancing-video" element={
              <ProtectedRoute>
                <WorkflowProjectPage />
              </ProtectedRoute>
            } /> */}
            <Route path="/profile" element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;